'use client';
import React, { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import {
  Monitor,
  RouterContext,
  toMonitorProps,
  toRegionsData,
} from '@bufdir/monitor-pages-components';

type Props = {
  groupSlug?: string;
  slug: string;
  monitorData: any;
  geoData: any;
  router: {
    useRouter: () => any;
    usePathname: () => any;
    useSearchParams: () => any;
  };
};

const PageMonitor: React.FC<Props> = ({
  geoData,
  groupSlug,
  slug,
  monitorData,
  router,
}) => {
  const [hash, setHash] = useState('');

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 10 * (60 * 1000),
        gcTime: 15 * (60 * 1000),
      },
    },
  });

  useEffect(() => {
    setHash(window.location.hash);
  }, []);

  const regionsData = toRegionsData(geoData);
  const monitorProps = toMonitorProps(
    monitorData,
    monitorData.monitorApiUrl,
    regionsData,
    slug,
  );

  return (
    <RouterContext.Provider
      value={{
        ...router,
      }}
    >
      <QueryClientProvider client={queryClient}>
        <Monitor
          {...monitorProps}
          {...(groupSlug ? { groupSlug } : {})}
          hash={hash}
        />
      </QueryClientProvider>
    </RouterContext.Provider>
  );
};

export default PageMonitor;
